import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "./login/-LoginPage";

export const Route = createFileRoute("/")({
  component: LoginPage,
});
